export const routes = {

    chapterPage: (courseId, moduleName, chapterName, modulePage=false) => {
        if(modulePage) {
            return `${courseId}/${moduleName}`
        }
        return `${courseId}/${moduleName}/${chapterName}`
    },
    chapterPageAbs: (productName,courseId, moduleName, chapterName, modulePage=false) => {
        if(modulePage) {
            return `/produkt/${productName}/kurs/${courseId}/${moduleName}`
        }
        return `/produkt/${productName}/kurs/${courseId}/${moduleName}/${chapterName}`
    },
    previewPageAbs: (productName,courseId, moduleName, chapterName, modulePage=false) => {
        if(modulePage) {
            return `/butikk/${productName}/kurs/${courseId}/${moduleName}`
        }
        return `/butikk/${productName}/prov/${courseId}/${moduleName}/${chapterName}`
    },
    labPage: (experiment) => `${experiment}`,
    labPageAbs: (productName, experiment) => `/produkt/${productName}/lab/${experiment}`,
    storeProductAbs: (productName) => `/butikk/${productName}`,
    productHomeAbs: (productName) => `/produkt/${productName}/kurs`,
    coursePageAbs: (productName,courseId, moduleName, chapterName, modulePage=false, preview=false) => {
        if(preview) {
            return `/course/preview/${courseId}/${moduleName}/${chapterName}`
        }
        return `/produkt/${productName}/kurs/${courseId}/${moduleName}/${chapterName}`
    }

};